import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEThiemeTargetType, OEThiemeTargets, OEThiemeFeatureAccess, OEThiemeStartSelectionData} from './oe-thieme-model';

export default class OEThiemeCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEThiemeTargetType.head]:      {icon: OEIconCodes.thieme.headTarget, titleId: 'target_menu_head'},
            [OEThiemeTargetType.anatomy]:   {icon: OEIconCodes.thieme.anatomyTarget, titleId: 'target_menu_anatomy'},
            [OEThiemeTargetType.biology]:   {icon: OEIconCodes.thieme.biologyTarget, titleId: 'target_menu_biology'},
            [OETarget.effigosExplorerHelp]: {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEThiemeTargetType.anatomy, OEThiemeTargetType.head, OEThiemeTargetType.biology, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEThiemeTargets}
                featureAccess={OEThiemeFeatureAccess}
                startSelectionData={OEThiemeStartSelectionData}
            />
        );
    }
}